import React from 'react';
import Banner from '../../components/Banner/Banner';
import Main from '../../components/Main/Main';
import Aside from '../../components/Aside/Aside';
import Suggestions from '../../components/Suggestions/Suggestions';
import './landing-page.css';
import HeroHome from '../../components/HeroHome/HeroHome';
import Header from '../../components/Header/Header';
import { useTranslation } from 'react-i18next';

const LandingPage: React.FC = () => {
	const { t } = useTranslation();
	return (
		<>
			<Header>
				<span className="header__label">{t('landing_page.title')}</span>
				<h1 className="header__title">{t('landing_page.subtitle')}</h1>
			</Header>
			<div className="landing--page">
				{/*
        <Banner />
        <Aside />
        */}
				<HeroHome />
				<div className="landing__container">
					<div className="landing__row">
						<div className="landing__col landing__flex">
							<Main />
						</div>
						<div className="landing__col landing__fixed">
							<Suggestions />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default LandingPage;
